import { action, observable } from "mobx"
import shop from "shop/shop"
import languageStore from "stores/languageStore"

import _ from "lodash"
import {CategoryStore as BaseCategoryStore} from  "../../../stores/categoryStore" 

const MANUAL_ORDER = {
  "Spring / Summer"   : 0,
  "Autumn / Christmas": 1,
  "Promotion"         : 2,
  "Sale"              : 3,
  "All"               : 4,
  "Glass"             : 5,
  "Porcelain"         : 6,
  "Ceramic"           : 7,
  "Stoneware"              : 8,
  "Metal"              : 9,
  "Accessories"              : 99,
}

class CategoryStore extends BaseCategoryStore {

  @observable categories = []
  @observable rootCategories = []
  @observable rootFields = {}
  @observable categoriesById = new Map() // rename to singular
  @observable categoryByName = new Map()
  @observable all = []
  @observable hasFilter = false
  @observable hash = 0

  @action fetch() {
    const { currentLanguage } = languageStore
    return shop.fetch( `/shop/rest/data/categories/tree?lang=${currentLanguage}`, {
      credentials: "include",
      mode       : "cors",
    } )
      .then( categories => {
        this.categories = this.mapCategories( categories )

        this.categories = this.categories.sort( ( a, b ) => {
          const s1 = MANUAL_ORDER[ a.desc.short_des.trim() ]
          const s2 = MANUAL_ORDER[ b.desc.short_des.trim() ]

          return s1 <= s2 ? -1 : 1
        } )

        this.sortRootCategories()
        console.timeEnd( "CATS" )
        return this.categories
      } )
      .catch( err => {
        console.error( "Error fetching categories", err )
      } )
  }

  @action
  showFilter() {
    this.hasFilter = true
  }

  @action
  hideFilter() {
    this.hasFilter = false
  }

  @action
  updateCategories() {
    this.all.forEach( category => category.update() )
    this.hash += 1
  }

  mapCategories = ( categories, level = 0 ) => {
    const sorted = categories.sort( baseSort ).map( data => {
      let category = new shop.CategoryModel( data )
      category.level = level
      if ( category.level === 0 ) {
        this.rootCategories.push( category )
      }
      category.children = this.mapCategories( category.children, level + 1 )
      this.categoriesById.set( category.map_id, category )
      this.categoryByName.set( category.desc.des, category )
      this.all.push( category )
      return category
    } )

    return sorted
  }

  sortRootCategories() {
    const buckets = {}

    this.rootCategories.forEach( category => {
      let fields = category.meta.submeta.fields
      if ( shop.config.pickFilter ) {
        fields = _.pick( category.meta.submeta.fields, shop.config.pickFilter )
      }
      _.forEach( fields, ( values, key ) => {
        const bucket = buckets[ key ] || {}
        values.forEach( value => {
          bucket[ value ] = true
        } )
        buckets[ key ] = bucket
      } )
    } )

    this.rootFields = buckets
  }

}

const baseSort = ( a, b ) => {
  if ( !a || !b ) return 0
  if ( Number( a.sort ) > Number( b.sort ) ) return 1
  if ( Number( a.sort ) < Number( b.sort ) ) return -1
  return 0
}

const categoryStore = new CategoryStore()
window[ "categoryStore" ] = categoryStore

export default categoryStore



// WEBPACK FOOTER //
// ./src/theme/sandra/stores/categoryStore.js